import axiosInstance from "../../app/apiClient";
import { DataParam, MenuAdminService } from "../model/menu.model";


export const getMenuData = (fromDate: any, toDate: any, kitchenId: any, isSpecial: string) => {
    return axiosInstance.get(`/api/v1/menus?fromDate=${fromDate}&toDate=${toDate}&kitchenId=${kitchenId}&isSpecial=${isSpecial}`).then(item => item).catch(err => err);}
const addMenu = (data: DataParam) => axiosInstance.post(`api/v1/menus`, data);
const updateMenu = (data: DataParam, id: number) => axiosInstance.put(`api/v1/menus/${id}`, data)
const removeMenu = (id: number) => axiosInstance.delete(`api/v1/menus/${id}`)
const getOneMenu = (id: number) => axiosInstance.get(`api/v1/menus/${id}`)
const importMenus = (kitchenId: number, file: any) => axiosInstance.post(`api/v1/menus/upload-excel?kitchenId=${kitchenId}`, file)
const menusAdmin: MenuAdminService = {
    getMenuData,
    addMenu,
    updateMenu,
    removeMenu,
    getOneMenu,
    importMenus
}
export default menusAdmin;
